export const C = {
  primary:        '#02A74A',
  primaryDark:    '#017A36',
  primaryLight:   '#E8F5EE',
  secondary:      '#2261C6',
  secondaryLight: '#EEF3FD',
  bg:             '#F4F6F8',
  card:           '#FFFFFF',
  border:         '#E2E8F0',
  text1:          '#0F172A',
  text2:          '#64748B',
  text3:          '#94A3B8',
  sidebarBg:      '#1E293B',
  sidebarText:    '#94A3B8',
  inputBg:        '#F8FAFC',
  warning:        '#F59E0B',
  warningLight:   '#FFFBEB',
  error:          '#EF4444',
  errorLight:     '#FEF2F2',
  white:          '#FFFFFF',
} as const;

export const STATUS_COLORS: Record<string, string> = {
  ACTIVE:  C.primary,
  WARNING: C.warning,
  ERROR:   C.error,
  OFFLINE: C.text3,
};
export const STATUS_LABELS: Record<string, string> = {
  ACTIVE: '정상', WARNING: '경고', ERROR: '오류', OFFLINE: '오프라인',
};

export const ROLE_COLORS: Record<string, string> = {
  ADMIN:    C.secondary,
  OPERATOR: C.primary,
  VIEWER:   C.text2,
};
export const ROLE_LABELS: Record<string, string> = {
  ADMIN: '관리자', OPERATOR: '운영자', VIEWER: '뷰어',
};

export const shadow = {
  sm: { boxShadow: '0 1px 3px rgba(0,0,0,0.06),0 1px 2px rgba(0,0,0,0.04)' },
  md: { boxShadow: '0 4px 12px rgba(0,0,0,0.08)' },
} as const;
